import { useContext } from 'react';
import { ProductLayoutContext } from './../../contexts/productLayoutContext';

export const useProductLayout = () => useContext(ProductLayoutContext);
